import { Node, Plugin } from 'tiptap'
import _ from 'lodash'
import store from '../../store'
import router from '../../routes'

export default class NestedPage extends Node {

  get name() {
    return 'nested_page'
  }

  get plugins() {
    return [
      new Plugin({
        props: {
          handleKeyDown: (view, event) => {
            if (event.which === 8 || event.which === 46) {
              view.state.deleting = true
            }
          },
          handleClick: (view, pos, e) => {
            const owner = !e.path.find((val) => val.classList.contains('editor')).classList.contains('is-read-only');
            const draft = e.path[0].getAttribute('data-draft') ==='true'
            if (!e || !e.path || !e.path[0] || (draft && !owner)) return
            let page = e.path[0].getAttribute('data-page')
            if (!page) return
            return router.push({ name: 'page', params: { page_id: page }})
          }
        },
        filterTransaction: (transaction, state) => {
          if (!state.deleting) return true
          let result = true
          _.each(transaction.mapping.maps, (map) => {
            map.forEach((oldStart, oldEnd) => {
              state.doc.nodesBetween(oldStart, oldEnd, (node) => {
                if (node.type.name === 'nested_page' && node.attrs && node.attrs.page) {
                  store.commit('CONFIRM_DELETE', node.attrs.page)
                  result = false
                }
              })
            })
          })
          return result
        }
      })
    ]
  }

  get schema() {
    return {
      attrs: {
        href: {
          default: null,
        },
        content: {
          default: 'Untitled'
        },
        page: {
          default: '0'
        },
        draft: {
          default: 'false'
        },
        paid: {
          default: 'false'
        }
      },
      group: 'block',
      content: 'block',
      isolating: true,
      draggable: true,
      parseDOM: [
        {
          tag: `p[data-type="${this.name}"]`,
          priority: 60,
          getAttrs: dom => {
            return {
              class: dom.getAttribute('class'),
              // href: dom.childNodes[0].getAttribute('href'),
              page: dom.childNodes[0].getAttribute('page'),
              'data-page': dom.childNodes[0].getAttribute('data-page'),
              'data-type': dom.childNodes[0].getAttribute('data-type'),
              draft: dom.childNodes[0].getAttribute('data-draft'),
              paid: dom.childNodes[0].getAttribute('data-paid'),
              'data-draft': dom.childNodes[0].getAttribute('data-draft'),
              'data-paid': dom.childNodes[0].getAttribute('data-paid'),
              content: dom.childNodes[0].textContent
            }
          }
        },
      ],
      toDOM: node => {
        const classes = 'editor__node-page-link' +
          (node.attrs.draft === 'true' ? ' editor__node-page-link-draft' : '') +
          (node.attrs.paid === 'true' ? ' editor__node-page-link-paid' : '')

        return [ 'p', {
            'data-type': this.name,
            'data-parent-for': node.attrs.page,
            class: 'editor__node-page'
          }, ['a', {
              class: classes,
              'data-type': this.name,
              page: node.attrs.page,
              'data-page': node.attrs.page,
              'data-draft': node.attrs.draft,
              'data-paid': node.attrs.paid,
              draft: node.attrs.draft,
              paid: node.attrs.paid
            }, node.attrs.content
          ]
        ]
      }
    }
  }

  commands({ type }) {
    return attrs => (state, dispatch) => {
      const { selection } = state;
      let position = selection.$cursor
        ? selection.$cursor.pos
        : selection.$head.pos;
      position = position - 1;
      const node = type.create(attrs);
      const transaction = state.tr.insert(position, node);
      dispatch(transaction);
    };
  }

}
